<template>

    <v-page-body>

        <transition name="modal">
            <v-modal-member-delete v-if="showModal === 'delete'" :member="member" />
        </transition>

        <v-page-filters v-if="member && member.role.slug !== 'owner'" floating>
            <v-button size="sm" btn-style="white-danger" @click.native="deleteMember">Delete</v-button>
         </v-page-filters>

        <v-page-section padded>
            <template #header>
                <span>Member</span>
                <v-identifier :uuid="member.id" />
            </template>
            <template #body>
                <v-list>
                    <v-list-item>
                        <span>{{ member.name | truncate(30) }}<br><span class="small"><a :href="'mailto:' + member.email">{{ member.email | truncate(30) }}</a></span></span>
                        <span>Role<br><span class="small">{{ member.role.name }}</span></span>
                        <span>Joined<br><span class="small">{{ member.created_at | date }}</span></span>
                    </v-list-item>
                </v-list>
            </template>
        </v-page-section>

        <v-page-section>
            <template #title>Permissions</template>
            <template #body>
                <v-form-group label="Role" caption="The permissions assigned to this member.">
                    <v-list grouped>
                        <v-list-item size="sm" v-for="r in roles" :key="r.id">
                            <div>
                                <span>{{ r.name }}</span><br>
                                <span class="small text-muted">{{ r.description }}</span>
                            </div>
                            <div class="d-flex align-items-center justify-content-end">
                                <v-button
                                    size="xs"
                                    :btn-style="params.role_id === r.id ? 'success' : 'secondary'"
                                    :btn-label="params.role_id === r.id ? 'Selected' : 'Select'"
                                    @click.native="selectRole(r.id)">
                                </v-button>
                            </div>
                        </v-list-item>
                    </v-list>
                </v-form-group>
                <v-form-group v-if="params.role_id !== ownerRole.id" label="Projects" caption="The projects this member can access.">
                    <v-list grouped>
                        <v-list-item size="sm" v-for="p in projects" :key="p.id">
                            <div>
                                <span>{{ p.name }}<br></span>
                                <span class="small text-muted">{{ p.website }}</span>
                            </div>
                            <div class="d-flex align-items-center justify-content-end">
                                <v-button
                                    size="xs"
                                    :btn-style="params.project_ids.includes(p.id) ? 'success' : 'secondary'"
                                    :btn-label="params.project_ids.includes(p.id) ? 'Selected' : 'Select'"
                                    @click.native="selectProject(p.id)">
                                </v-button>
                            </div>
                        </v-list-item>
                    </v-list>
                </v-form-group>
            </template>
            <template #footer>
                <v-button btn-label="Save" size="sm" :loading="loading" @click.native="updateMember"></v-button>
            </template>
        </v-page-section>

    </v-page-body>

</template>

<script>

import axios from 'axios';
import CompanyApi from '@api/CompanyApi';
import MemberApi from '@api/MemberApi';
import ModalMemberDelete from '@modals/member/ModalMemberDelete';
import RoleApi from '@api/RoleApi';

export default {

    components: {
        'v-modal-member-delete': ModalMemberDelete,
    },

    data() {
        return {
            loading: false,
            member: null,
            roles: [],
            projects: [],
            params: {
                role_id: '',
                project_ids: [],
            },
        }
    },

    computed: {

        roleItems() {
            return this.roles.map(r => {
                return { value: r.id, title: r.name, desc: r.description };
            });
        },

        ownerRole() {
            return this.roles.find(r => r.slug === 'owner');
        },

    },

    mounted() {
        this.getMember();
    },

    methods: {

        getMember() {
            this.$store.commit('loading', true);
            let requests = [
                MemberApi.getMember(this.$route.params.member_id),
                RoleApi.getRoles(),
                CompanyApi.getProjects(this.$store.getters.company.id),
            ];
            axios.all(requests)
                .then(axios.spread((resMember, resRoles, resProjects) => {
                    this.$store.commit('loading', false);
                    this.member = resMember.data.data;
                    this.roles = resRoles.data.data;
                    this.projects = resProjects.data.data;
                    // Set params.
                    this.params.role_id = this.member.role.id;
                    this.params.project_ids = this.member.projects.map(p => p.id);
                    this.$events.$emit('pageLoaded');
                }), () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        updateMember() {
            this.loading = true;
            MemberApi.updateMember(this.member.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                }, (error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

        selectRole(id) {
            this.params.role_id = id;
            if (id === this.ownerRole.id) {
                this.params.project_ids = this.projects.map(p => p.id);
            }
        },

        selectProject(id) {
            let index = this.params.project_ids.findIndex(p => p === id);
            if (index >= 0) {
                this.params.project_ids.splice(index, 1);
            } else {
                this.params.project_ids.push(id);
            }
        },

        deleteMember() {
            this.$store.commit('showModal', 'delete');
        },

    },

}

</script>